"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var image_picker_1 = __importDefault(require("./image-picker"));
var App = function (_a) {
    var showRating = _a.showRating, excludeFree = _a.excludeFree;
    return (0, jsx_runtime_1.jsx)(image_picker_1.default, { excludeFree: excludeFree });
};
exports.default = App;
